import { Card, Typography, Grid, Stack, Divider } from '@mui/material';
import ReactApexChart from 'react-apexcharts';
import formatMoney from 'src/utils/formatMoney';

// TCV composition (TCI / One-Time SaaS / Other) as a stacked bar + ARR/MRR tiles.
export default function FinancialBreakdown({ financial, currencyLabel }) {
  if (!financial) return null;
  const num = (v) => Number(v || 0);

  const chart = {
    series: [
      { name: 'TCI', data: [num(financial.tci)] },
      { name: 'One-Time SaaS', data: [num(financial.one_time_saas)] },
      { name: 'Other', data: [num(financial.tcv_other)] },
    ],
    options: {
      chart: { type: 'bar', stacked: true, toolbar: { show: false }, height: 180 },
      plotOptions: { bar: { horizontal: true, borderRadius: 4 } },
      xaxis: { categories: ['TCV'], labels: { formatter: (v) => formatMoney(v, currencyLabel) } },
      dataLabels: { enabled: false },
      legend: { position: 'bottom' },
      colors: ['#1976d2', '#9c27b0', '#90a4ae'],
      tooltip: { y: { formatter: (v) => formatMoney(v, currencyLabel) } },
    },
  };

  const rows = [
    { label: 'Total Contract Value', value: financial.total_contract_value },
    { label: 'TCI', value: financial.tci },
    { label: 'One-Time SaaS', value: financial.one_time_saas },
    { label: 'Other', value: financial.tcv_other },
  ];

  return (
    <Card sx={{ p: 2, mb: 3 }}>
      <Typography variant="h6" fontWeight={600} mb={2}>Financial Breakdown</Typography>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12} md={7}>
          <ReactApexChart options={chart.options} series={chart.series} type="bar" height={180} />
        </Grid>
        <Grid item xs={12} md={5}>
          <Stack spacing={0.75}>
            {rows.map((r) => (
              <Stack key={r.label} direction="row" justifyContent="space-between">
                <Typography variant="body2" color="text.secondary">{r.label}</Typography>
                <Typography variant="body2" fontWeight={600}>{formatMoney(r.value, currencyLabel)}</Typography>
              </Stack>
            ))}
            <Divider sx={{ my: 1 }} />
            <Grid container spacing={1}>
              <Grid item xs={6}>
                <Typography variant="caption" color="text.secondary" sx={{ textTransform: 'uppercase' }}>MRR</Typography>
                <Typography variant="h5" fontWeight={700}>{formatMoney(financial.mrr, currencyLabel)}</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="caption" color="text.secondary" sx={{ textTransform: 'uppercase' }}>ARR</Typography>
                <Typography variant="h5" fontWeight={700}>{formatMoney(financial.arr, currencyLabel)}</Typography>
              </Grid>
            </Grid>
          </Stack>
        </Grid>
      </Grid>
    </Card>
  );
}
